import React from "react";
import sunset from "../assets/escavsun.webp";
import er from "../assets/er.png";
import bg from "../assets/bg3.webp";
import car1 from "../assets/car1.jpg"
import car2 from "../assets/car2.jpg"
import car3 from "../assets/car3.jpg"
import esc1 from "../assets/esc1.jpg"
import esc2 from "../assets/esc2.jpg"
import esc3 from "../assets/esc3.jpg"

function Hero() {
  return (
    <>
      <section
        className="bg-cover bg-center flex items-center justify-center text-black p-5"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="text-center bg-opacity-75 p-8 rounded flex-col my-5">
          <img className="w-16 float-left" src={er} alt="" />
          <h1 className="text-3xl font-bold text-customRed">
            Noleggio mini escavatori
          </h1>

          <p className="text-lg mt-5">Qualità e Affidabilità al tuo Servizio</p>
        </div>
      </section>

      <section
        id="chi-siamo"
        className="p-8 bg-stone-100 rounded-sm shadow-sm h-full"
      >
        <h2 className="text-2xl font-bold mb-4 text-customRed text-center">
          Chi Siamo
        </h2>
        <img
          className="float-left w-36 mr-4 rounded-md shadow-sm"
          src={sunset}
          alt=""
        />
        <p className="p-8">
          Siamo una nuova azienda nel settore del noleggio di escavatori,
          impegnata a offrire soluzioni personalizzate per le vostre esigenze di
          scavo e movimento terra. Il nostro sito è attualmente in fase di costruzione,
          ma siamo entusiasti di iniziare questa nuova avventura con voi. Per
          qualsiasi informazione o richiesta, non esitate a contattarci tramite
          WhatsApp.
        </p>
      </section>

      <section id="servizi" className="p-8 mb-10 bg-stone-200 rounded-sm shadow-sm">
  <h2 className="text-2xl font-bold mb-4 text-customRed">I Nostri Servizi</h2>
  <ul className="list-disc ml-5">
    <li className="mt-2">
      Noleggio Motocariola con conduttore: 170€ al giorno.
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        <img src={car1} alt="Motocariola 1" className="w-full h-auto rounded-sm shadow-sm" />
        <img src={car2} alt="Motocariola 2" className="w-full h-auto rounded-sm shadow-sm" />
        <img src={car3} alt="Motocariola 3" className="w-full h-auto rounded-sm shadow-sm" />
        {/* <img src={car1} alt="Motocariola 4" className="w-full h-auto rounded-sm shadow-sm" /> */}
      </div>
    </li>
    <li className="mt-2">
      Noleggio mini escavatore 16 quintali con conduttore: 400€ al giorno.
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        <img src={esc1} alt="Escavatore 1" className="w-full h-auto rounded-sm shadow-sm" />
        <img src={esc2} alt="Escavatore 2" className="w-full h-auto rounded-sm shadow-sm" />
        <img src={esc3} alt="Escavatore 3" className="w-full h-auto rounded-sm shadow-sm" />
        {/* <img src={esc1} alt="Escavatore 4" className="w-full h-auto rounded-sm shadow-sm" /> */}
      </div>
    </li>
  </ul>
  <h2 className="font-bold my-5"> Nota sui Prezzi e le Condizioni di Noleggio </h2>
  <p>
    I prezzi rappresentano le tariffe base e possono variare in base a diversi fattori, tra cui la durata del noleggio, la tipologia di lavoro richiesto e le specifiche necessità del progetto. <br /><br />
    In questa fase iniziale, per garantire la massima sicurezza e qualità del servizio, i nostri escavatori verranno noleggiati esclusivamente con conducente. Questa misura temporanea ci permette di instaurare un rapporto di fiducia con i nostri clienti, eliminando la necessità di richiedere una cauzione.<br /><br />
    Essendo un'azienda emergente, ci rendiamo disponibili per discutere con voi ogni dettaglio. Per qualsiasi informazione aggiuntiva o per richieste specifiche, non esitate a contattarci su WhatsApp. Saremo lieti di assistervi e rispondere a tutte le vostre domande.
  </p>
</section>

    </>
  );
}

export default Hero;
